import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { createErrorDetails, getErrorMessage, getErrorTitle } from '../../../dmpconnect/errors';
import ErrorDetails from './ErrorDetails';
import Alert from './Alert';
import {objectWithoutTheseKeys} from "../../../dmpconnect/utils/dataUtils";

export default function ErrorMessage({
  error, title, message, showDetails,
}) {
  const [details, toggleDetails] = React.useState(false);
  return (
    <div>
      <Alert type="danger">
        <div className="typography-big-text-title">
          {title || getErrorTitle(error)}
        </div>
        {message || error.customErrorMessage || getErrorMessage(error)}
        {showDetails && (
          <div className="mt-2">
            <Button
              variant="outline-danger"
              size="sm"
              onClick={() => toggleDetails(true)}
            >
              Afficher le détails de l&apos;erreur
            </Button>
          </div>
        )}
      </Alert>
      {showDetails && (
        <Modal show={details} onHide={() => toggleDetails(false)}>
          <Modal.Header closeButton>Erreur détaillée</Modal.Header>
          <Modal.Body>
            <ErrorDetails details={[createErrorDetails('erreur', objectWithoutTheseKeys(error, ['customErrorMessage']))]} />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="outline-secondary" onClick={() => toggleDetails(false)}>Fermer</Button>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  );
}

ErrorMessage.defaultProps = {
  title: '',
  message: '',
  showDetails: false,
};

ErrorMessage.propTypes = {
  error: PropTypes.object.isRequired,
  message: PropTypes.node,
  title: PropTypes.string,
  showDetails: PropTypes.bool,
};
